var FlightBoardSearch = (function ($) {
    FlightBoardSearch = function (options) {
        var that = this;

        // DOM
        that.$wrapper = options["$wrapper"];
        that.$form_wrapper = options["$form_wrapper"];
        that.$list_wrapper = $(options["list_wrapper_class"]);
        that.$input = options["$input"];
        that.$hide_completed_checkbox = options["$hide_completed_checkbox"];

        // DYNAMIC VARS
        that.timer = null;

        // CONST
        that.page = options["page"];
        that.list_wrapper_class = options["list_wrapper_class"];

        // INIT
        that.init();
        that.initPagination();
    };

    FlightBoardSearch.prototype.init = function () {
        var that = this;
        that.initWorker();
    };

    FlightBoardSearch.prototype.initPagination = function () {
        var that = this,
            url = new URL(window.location.href);
        $.sa.pagination(that.$wrapper, url.toString());
    };

    FlightBoardSearch.prototype._refreshPageWithNewSearchParams = function (params, partial = false) {
        var that = this,
            url = new URL(window.location.href);

        $.each(params, function (index, value) {
            url.searchParams.set(index, value.toString());
        });

        if(partial) {
            var content_uri = url.toString();
            that.$input.prop('disabled', true);
            
            $.get(content_uri, function (res) {
                var partial_content = $('<div />').html(res).find(that.list_wrapper_class).html();
                that.$list_wrapper.html(partial_content);
            }).done(function() {
                
                // set url
                history.pushState({
                    reload: true,               // force reload history state
                    content_uri: content_uri    // url, string
                }, "", content_uri);

                that.initPagination();
                that.$input.prop('disabled', false);
                that.$input.focus();
                
            });
        } else {
            $.sa.content_router.load(url.toString());
        }
    }

    FlightBoardSearch.prototype.initWorker = function () {
        var that = this;

        that.$input.on('input', function () {
            that.timer && clearTimeout(that.timer);
            that.timer = setTimeout(function () {
                var query = $.trim(that.$input.val().toLowerCase());
                var param_name = that.$input.attr('name') ?? 'query';

                if (query.length <= 256) {
                    that._refreshPageWithNewSearchParams({
                        [param_name]: query
                    }, true);
                }
            }, 800);
        });

        that.$hide_completed_checkbox.on('change', function () {
            var param_name = that.$hide_completed_checkbox.attr('name') ?? 'hide_completed';
            that._refreshPageWithNewSearchParams({
                [param_name]: that.$hide_completed_checkbox.prop('checked') ? 1 : 0
            });
        });
    };

    return FlightBoardSearch;
})($);